import { searchService } from '@/api/search.service';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRefOrGetter, toRef, toValue } from 'vue';

const QUERY_KEY = 'global-search';

export const useGlobalSearch = (
  query: MaybeRefOrGetter<string>,
  enabled: MaybeRefOrGetter<boolean> = true,
) => {
  return useQuery({
    queryKey: [QUERY_KEY, toRef(query)],
    queryFn: () => searchService.search(toValue(query)),
    enabled: () => toValue(enabled) && toValue(query).trim().length > 0,
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
};
